export enum RoutePrefix {
  CLIENTS = "/clients",
  USERS = `/keycloak/users`,
  SERVICES = "/services",
  TOGGLE_STATUS = "/toggleActivation",
  CLIENT_SERVICES = "/client-services",
  SERVICE_REQUEST = "/service-requests/by-client",
}
